export default __webpack_public_path__ + "static/media/cp_geo_to.6678aeed.svg";